export const saveLocalData = (key, value) => {
  localStorage.setItem(key, value);
};

export const getLocalData = (key) => {
  return localStorage.getItem(key);
};

export const removeLocalData = (key) => {
  localStorage.removeItem(key);
};
